import type { ReactNode } from "react";
import { Typography, Box, Skeleton } from "@mui/material";
import type { Metier } from "models";
import CompetenceChip from "components/CompetenceChip";

interface MetierBoxProps {
  metier: Partial<Metier>;
  isLoading?: boolean;
  noWrap?: boolean;
}

export function MetierBox({
  metier: { competence, libelle },
  isLoading = false,
  noWrap = false,
}: Readonly<MetierBoxProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Typography noWrap={noWrap}>
        {competence != null && <CompetenceChip competence={competence} sx={{ marginRight: 1 }} />}
        {libelle}
      </Typography>
    </Box>
  );
}
